<mt-toast-drawer
  [attr.aria-hidden]="sessionSynchronizing() ? 'true' : null"
  [attr.inert]="sessionSynchronizing() ? '' : null">
</mt-toast-drawer>

<main
  #shell
  [attr.aria-busy]="sessionSynchronizing()"
  [class.app-shell_create-event-fab-visible]="createEventFabVisible()">
  <section
    #route
    class="route"
    [attr.aria-hidden]="sessionSynchronizing() ? 'true' : null"
    [attr.inert]="sessionSynchronizing() ? '' : null">
    <router-outlet></router-outlet>
  </section>
  @if (bottomChromeVisible() && !sessionSynchronizing()) {
    @if (createEventFabVisible()) {
      <app-create-event-fab (createRequested)="openEventCreation($event)">
      </app-create-event-fab>
    }
    <app-menu-tabs
      class="menu-tabs"
      [activeContext]="activeContext()">
    </app-menu-tabs>
  }
</main>
